var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-3 text-right"},[_c('b-button',_vm._g({attrs:{"variant":"primary"}},_vm.$listeners),[_c('Bullseye',{staticClass:"mr-2"}),_c('strong',[_vm._v(_vm._s(_vm.$t('label')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }